<template>
  <div>
    <div class="here-info-window-content coverage driver driver-info">
      <div class="header">
        <div class="photo" v-bind:style="{ 'background-image': 'url(\'' + driver.photo + '\')'}"></div>
        <div class="name"><a :href="'/#/provider/' + driver.driverId" target="_blank">{{ driver.name }}</a></div>
        <div class="email"><a :href="'mailto:' + driver.email">{{ driver.email }}</a></div>
        <div class="email"><a href="javscript:;" @click="callDriver(driver)">{{ driver.phone }}</a></div>
      </div>

      <div class="vehicle">
        <div class="photo" v-bind:style="{ 'background-image': 'url(\'' + driver.vehicle.photoUrl + '\')'}"></div>
        <div class="name">{{ driver.vehicle.manufacturer }} {{ driver.vehicle.model }}</div>
        <div class="plate-number">{{ driver.vehicle.licensePlate }}</div>
      </div>

      <div class="shift-info" v-if="driver.shiftStart !== null && driver.shiftEnd !== null">
        <i class="fa fa-check-circle"></i>
        <span>Available from</span>
        <span class="shift-value">{{ driver.shiftStart.format('hh:mmA') }}</span>
        <span>to</span>
        <span class="shift-value">{{ driver.shiftEnd.format('hh:mmA') }}</span>
      </div>

      <div class="rsvp-info" v-if="driver.rsvpId !== null">
        <i class="fa fa-car"></i>
        <span>Reservation</span>
        <a :href="'/#/reservation/' + driver.rsvpId" >{{ driver.rsvpId }}</a>
        <span>set to clear at</span><br/>
        <span class="highlight">{{ driver.dropoffTime.format('hh:mmA') }}.</span>
      </div>

      <div class="row controls" v-if="rsvp !== null">
        <div class="small-6 columns">
          <a class="button cta xsmall block" href="javascript:;" @click="sendToDriver(driver)">SEND TO {{ driver.firstName }}</a>
        </div>
        <div class="small-6 columns adjust-right">
          <a class="button cta xsmall block warning" href="javascript:;" @click="assignToDriver(driver)">ASSIGN TO {{ driver.firstName }}</a>
        </div>
      </div>
      <div class="row controls" v-if="rsvp === null">
        <div class="small-12 columns">
          <a class="button cta xsmall block" href="javascript:;" @click="createShift(driver)">CREATE A SHIFT FOR {{ driver.firstName }}</a>
        </div>
      </div>
      <i class="fa fa-home is-home" v-show="driver.isHomeBase"></i>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'driver-modal',
  data () {
    return {
      driver: {
        rsvpId: '',
        photo: '',
        driverId: '',
        name: '',
        email: '',
        phone: '',
        dropoffTime: moment(),
        firstName: '',
        isHomeBase: '',
        vehicle: {
          photoUrl: '',
          manufacturer: '',
          model: '',
          licensePlate: ''
        },
        shiftStart: moment(),
        shiftEnd: moment()
      }
    }
  },
  computed: {
    rsvp () { return this.$store.state.coverage.map.rsvp },
    hasOngoingCall () { return this.$store.state.phone.ongoing },
    coverageGap () { return this.$store.state.coverage.map.gap }
  },
  methods: {
    update (data) { this.driver = data },
    callDriver (driver) {
      let self = this
      self.$plugins.phone.startCall(self, {
        phone: driver.phone,
        name: driver.firstName + ' ' + driver.lastName
      })
    },
    sendToDriver (driver) {
      this.$store.commit('coverage/setTriggerAction', 'sendToDriver')
      this.$store.commit('coverage/setTriggerData', driver)
      this.$store.commit('coverage/setTriggerWatch', true)
    },
    assignToDriver (driver) {
      this.$store.commit('coverage/setTriggerAction', 'assignToDriver')
      this.$store.commit('coverage/setTriggerData', driver)
      this.$store.commit('coverage/setTriggerWatch', true)
    },
    createShift (driver) {
      this.$store.commit('coverage/setCoverageShiftFormDriver', driver)
      this.$store.commit('coverage/setCoverageShiftFormGap', this.coverageGap)
      this.$store.commit('coverage/setCoverageShiftFormSector', this.$store.state.coverage.map.sector)
      this.$store.commit('coverage/setCoverageShiftFormShow', true)
    },
  },
}
</script>

<style lang="scss" scoped>
.driver-info {
  font-family: 'Open Sans', sans-serif;
  padding: 5px 0 0 5px;
  text-align: left;

  & .header {
    position: relative;
    min-height: 50px;
    padding-left: 60px;
    padding-top: 0px;
    padding-right: 15px;
  }

  & .photo {
    position: absolute;
    top: 0;
    left: 0;
    width: 50px;
    height: 50px;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 50px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.3);
    border: 1px solid rgba(0,0,0,0.3);
  }

  & .name {
    font-size: 14px;
    line-height: 14px;
    font-weight: 700;
  }

  & .email {
    font-size: 12px;
    line-height: 12px;
    margin-top: 5px;
    word-break: break-word;
  }

  & .vehicle {
    margin-top: 10px;
    position: relative;
    min-height: 50px;
    padding-left: 60px;
    padding-top: 10px;
  }

  & .shift-info {
    font-size: 14px;
    line-height: 14px;
    margin-top: 15px;
    text-align: center;

    & > * {
      display: inline-block;
      vertical-align: middle;
    }

    & i { color: #26D97A; }

    & .shift-value {
      font-weight: 700;
      color: #0D79F2;
    }
  }

  & .rsvp-info {
    font-size: 14px;
    line-height: 16px;
    margin-top: 15px;
    text-align: center;

    & .highlight, a {
      font-weight: 700;
      color: #0D79F2;
    }
  }

  & .controls {
    margin-top: 15px;

    & .padding-R { padding-right: 3px; }
    & .padding-L { padding-left: 3px; }
    .adjust-right{
      position: relative;
      left: 10px;
    }

    & .button {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  & .is-home {
    position: absolute;
    top: 35px;
    right: 10px;
    width: 30px;
    height: 30px;
    border-radius: 30px;
    background-color: #26D97A;
    text-align: center;
    line-height: 30px;
    color: #fff;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Coverage/DriverModal.vue